import { __assign } from "tslib";
import { validateAndBuildConfiguration } from '@datadog/browser-core';
import { buildEnv } from '../boot/buildEnv';
export function validateAndBuildLogsConfiguration(initConfiguration) {
  var baseConfiguration = validateAndBuildConfiguration(initConfiguration, buildEnv);
  if (!baseConfiguration) {
    return;
  }
  return __assign(__assign({}, baseConfiguration), {
    forwardErrorsToLogs: !!initConfiguration.forwardErrorsToLogs
  });
}